 

import type { RouteObject } from 'react-router';
import { lazyRoute, lazyRouteWithProps } from '../utils/lazyRoute';

const fleetRoutes: RouteObject[] = [
  {
    path: 'FLEET/Settings/*',
    children: [
      { path: 'Workshop', lazy: lazyRoute(() => import('../../pages/FLEET/FleetSettings/Workshop/Index')) },
      { path: 'Workshop/:id/Edit', lazy: lazyRoute(() => import('../../pages/FLEET/FleetSettings/Workshop/UppdateWorkShop')) },

      { path: 'Locations', lazy: lazyRoute(() => import('../../pages/FLEET/FleetSettings/Locations/Index')) },
      { path: 'Locations/:id/Edit', lazy: lazyRoute(() => import('../../pages/FLEET/FleetSettings/Locations/UppdateLocations')) },

      { path: 'Manufacturers', lazy: lazyRoute(() => import('../../pages/FLEET/FleetSettings/Manufacturer/Index')) },

      { path: 'Model', lazy: lazyRoute(() => import('../../pages/FLEET/FleetSettings/Model/Index')) },

      { path: 'FleetElementScan', lazy: lazyRoute(() => import('../../pages/FLEET/FleetScan/ScanElement/Index')) },
      {
        path: 'FleetElementScan/:catagory/:lookupType?/AddScanElement',
        lazy: lazyRoute(() => import('../../pages/FLEET/FleetScan/ScanElement/AddElement'))
      },

      { path: 'Drivers', lazy: lazyRoute(() => import('../../pages/FLEET/FleetSettings/Drivers/Index')) },
      { path: 'Owners', lazy: lazyRoute(() => import('../../pages/FLEET/FleetSettings/Owners/Index')) },

      { path: 'Suppliers', lazy: lazyRoute(() => import('../../pages/FLEET/FleetSettings/Suppliers/Index')) },
      { path: 'Suppliers/AddSupplier', lazy: lazyRoute(() => import('../../pages/PUR/Settings/Suppliers/Add')) },
      { path: 'Suppliers/:Id/UpdateSupplier', lazy: lazyRoute(() => import('../../pages/FLEET/FleetSettings/Suppliers/EditSuppliers')) }
    ]
  },

  {
    path: 'FLEET/*',
    children: [
      { path: 'HomePage', lazy: lazyRoute(() => import('../../pages/FLEET/DashBoard/FleetDashboard')) },

      // Equipment Inspection
      { path: 'EquipmentInspection', lazy: lazyRoute(() => import('../../pages/FLEET/FleetScan/ScanEquipments/Index')) },
      {
        path: 'EquipmentInspection/:fleetEquipmentsId/:lookupType/AddScan',
        lazy: lazyRoute(() => import('../../pages/FLEET/FleetScan/ScanEquipments/AddScan'))
      },
      {
        path: 'EquipmentInspection/:fleetEquipmentsId/ScanningList',
        lazy: lazyRoute(() => import('../../pages/FLEET/FleetScan/ScanEquipments/ScanningList'))
      },
      {
        path: 'EquipmentInspection/:fleetEquipmentsId/ScanningList/:id/Edit',
        lazy: lazyRoute(() => import('../../pages/FLEET/FleetScan/ScanEquipments/UpdateScan2'))
      },

      // Equipments (لاحظ: عندك VehicleCard بديل عن Equipments)
      { path: 'Equipments', lazy: lazyRoute(() => import('../../pages/FLEET/Equipments/VehicleCard')) },

      { path: 'Equipments/:Id/ExtraRecordEquipments', lazy: lazyRoute(() => import('../../pages/FLEET/Equipments/ExtraRecord/ExtraRecordEquipments')) },
      { path: 'Equipments/:Id/EquipmentsAssignation', lazy: lazyRoute(() => import('../../pages/FLEET/EquipmentsAssignment/EquipmentsAssignment')) },
      { path: 'Equipments/:Id/EquipmentsOdometer', lazy: lazyRoute(() => import('../../pages/FLEET/EquipmentsOdometer/EquipmentsOdometer')) },

      { path: 'Equipments/:Id/EquipmentRoutes', lazy: lazyRoute(() => import('../../pages/FLEET/EquipmentRoutes/AddEquipmentRoutes')) },
      {
        path: 'Equipments/:Id/EquipmentRoutes/:equipmentRoutesID/Edit',
        lazy: lazyRoute(() => import('../../pages/FLEET/EquipmentRoutes/EditEquipmentRoutes'))
      },
      {
        path: 'Equipments/:Id/EquipmentRoutes/:equipmentRoutesID/AssignmentRoutes',
        lazy: lazyRoute(() => import('../../pages/FLEET/AssignmentRoutes/AssignmentRoutes'))
      },

      // HandOver / TakeOver
      { path: 'HandOver', lazy: lazyRoute(() => import('../../pages/FLEET/HandOverTakeOver/CardHandOver')) },
      { path: 'HandOver/:Id/HandOverForm', lazy: lazyRoute(() => import('../../pages/FLEET/HandOverTakeOver/HandOver')) },

      { path: 'TakeOver', lazy: lazyRoute(() => import('../../pages/FLEET/HandOverTakeOver/CardTakeOver')) },
      { path: 'TakeOver/:Id/TakeOverForm', lazy: lazyRoute(() => import('../../pages/FLEET/HandOverTakeOver/TakeOver')) },

      // Work Requests
      { path: 'WorkRequests', lazy: lazyRoute(() => import('../../pages/FLEET/WorkRequests/WorkRequestList')) },
      { path: 'WorkRequests/:Id/AddWorkRequest', lazy: lazyRoute(() => import('../../pages/FLEET/WorkRequests/AddWorkRequest')) },

      // Work Order
      { path: 'WorkOrder', lazy: lazyRoute(() => import('../../pages/FLEET/WorkOrder/Index')) },
      { path: 'WorkOrder/AddWorkOrder/:requestId?', lazy: lazyRoute(() => import('@pages/FLEET/WorkOrder/Add')) },
      { path: 'WorkOrder/UpdateWorkOrder/:Id', lazy: lazyRoute(() => import('@pages/FLEET/WorkOrder/Update')) },

      // Reports / Dashboards
      { path: 'Reports', lazy: lazyRoute(() => import('../../pages/FLEET/FLEETReports/FLEETReports')) },
      { path: 'FleetDashboard', lazy: lazyRoute(() => import('../../pages/FLEET/DashboardFLEET/DashboardFLEET')) },
      {
        path: 'Reports/:ReportId/ReportsBuilder',
        lazy: lazyRoute(() => import('../../pages/NTX/Reports/ReportsAllByModule/Reports/ReportsBuilder/ReportsBuilder'))
      },
      {
        path: 'FleetDashboard/:dashboardId/BuilderDashboard',
        lazy: lazyRoute(() => import('../../pages/NTX/DashboardManagament/BuilderDashboard/BuilderDashboard'))
      },

      // AccountingPeriod (prop)
      {
        path: 'AccountingPeriod',
        lazy: lazyRouteWithProps(
          () => import('../../pages/Finance/Settings/AccountingPeriod/Index'),
          () => ({ customProp: 'Fleet' as const })
        )
      }
    ]
  }
];

export default fleetRoutes;
